<div cdkDropList (cdkDropListDropped)="drop($event, $event.item.data.id)">
  @for (itemOption of itemOptions; track itemOption; let itemOptionIndex = $index) {
    <eas-editor-booking-item-option [cdkDragData]="itemOption" cdkDrag
      [itemOption]="itemOption"
      [itemOptionIndex]="itemOptionIndex"
      [levelLines]="levelLinesList[itemOptionIndex]"
      >
    </eas-editor-booking-item-option>
  }
</div>
